import { render } from "./Documentation.vue?vue&type=template&id=939d8420"
import script from "./Documentation.vue?vue&type=script&lang=js"
export * from "./Documentation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Documentation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "939d8420"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('939d8420', __exports__)) {
    console.log('reload')
    api.reload('939d8420', __exports__)
  }
  
  module.hot.accept("./Documentation.vue?vue&type=template&id=939d8420", () => {
    console.log('re-render')
    api.rerender('939d8420', render)
  })

}


export default __exports__